import Component from './NextPage.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionNextPage', Component);
  },
};
